import React, { useEffect, useState, useMemo, useContext } from "react";
import moment from "moment";

import { Image } from "uikit-react";
import { AppContexts } from "../../../providers";

import { getReservationDoorCode } from "./reservation-door-code";
import { host } from "../../../http";

import FeatherIcon from "../../common/FeatherIcon";
import ReservationNumber from "../../common/ReservationNumber";
import NewMessageService from "../../../services/new-message.service";

const CATEGORY_OPTIONS = {
  owner: "Owner",
  housekeeper: "Housekeeper",
  maintenance: "Maintenance",
  vendor: "Vendor",
  leads: "Lead",
  other: "Other",
};

const sortByCheckInDesc = (a, b) =>
  moment(b.check_in, "YYYY-MM-DD").valueOf() -
  moment(a.check_in, "YYYY-MM-DD").valueOf();

const sortByCheckInAsc = (a, b) =>
  moment(a.check_in, "YYYY-MM-DD").valueOf() -
  moment(b.check_in, "YYYY-MM-DD").valueOf();

const formatMoney = (n) =>
  Number(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const EmailDetails = ({
  thread,
  currentUserId,
  currentPersonalInboxId,
  onSubjectUpdated,
}) => {
  const { user } = useContext(AppContexts.AuthContext);

  const source = (thread.sources || [])[0] || null;
  const isTeamGroup = () => false;
  const subject = "Email Thread";

  const participants = source?.participants || [];
  const isGroup = isTeamGroup(thread);
  const participantCount = Math.max(
    participants.length,
    thread?.participant_ids?.length || 0,
  );
  const threadId = thread?.id ?? thread?.thread_id;
  const iconSrc = isGroup
    ? "/images/private-message-team.svg"
    : "/images/private-message-individual.svg";
  const [editingName, setEditingName] = useState(false);
  const [draftName, setDraftName] = useState(thread?.label || "");
  const [savingName, setSavingName] = useState(false);
  const [nameError, setNameError] = useState("");
  const [selectedTabs, setSelectedTabs] = useState({});
  const [indexes, setIndexes] = useState({});

  let sortedReservations = useMemo(() => {
    const s = (thread.sources || [])[0] || null;
    const ps = source?.participants || [];

    const conns = {};

    ps.map((p) => {
      const current = [],
        upcoming = [],
        past = [],
        contacts = [];

      const today = moment().startOf("day");
      p.connections.forEach((it) => {
        let { reservation, contact, account } = it;

        if (!!account) {
          return;
        }

        if (!!contact) {
          contacts.push(contact);
        }

        if (!!reservation) {
          const checkIn = moment(reservation.check_in, "YYYY-MM-DD");
          const checkOut = moment(reservation.check_out, "YYYY-MM-DD");

          if (checkIn.isAfter(today)) {
            upcoming.push(reservation);
          } else if (checkOut.isBefore(today)) {
            past.push(reservation);
          } else {
            current.push(reservation);
          }
        }
      });

      conns[p.id] = {
        current: current.sort(sortByCheckInAsc),
        upcoming: upcoming.sort(sortByCheckInAsc),
        past: past.sort(sortByCheckInDesc),
        contacts: contacts,
      };
    });

    return conns;
  }, [thread]);

  useEffect(() => {
    const source = (thread.sources || [])[0] || null;
    const participants = source?.participants || [];

    setIndexes(
      participants.reduce((a, c) => {
        return {
          ...a,
          [c.id]: {
            current: 0,
            upcoming: 0,
            past: 0,
            contacts: 0,
          },
        };
      }, {}),
    );
  }, [thread]);

  const getBubble = (p) => {
    let accounts = (p.connections || []).filter((c) => !!c.account);
    let reservations = (p.connections || []).filter((c) => !!c.reservation);
    let contacts = (p.connections || []).filter(
      (c) => !!c.contact && c.contact.category !== "leads",
    );
    let leads = (p.connections || []).filter(
      (c) => !!c.contact && c.contact.category === "leads",
    );

    console.log(accounts);
    if (accounts.length > 0) {
      // TODO Need an icon for self
      return <Image src="/images/guest-active.svg" />;
    }

    if (contacts.length > 0) {
      return (
        <Image src={`/images/${contacts[0].contact.category}-active.svg`} />
      );
    }

    if (reservations.length > 0) {
      return <Image src="/images/guest-active.svg" />;
    }

    if (leads.length > 0) {
      return (
        <Image src={`/images/${contacts[0].contact.category}-active.svg`} />
      );
    }
  };

  const isSelf = (p) => {
    return !!(p.connections || []).find((c) => !!c.account);
  };

  const reservationTabs = (p) => {
    console.log(p, sortedReservations);

    return ["current", "upcoming", "past", "contacts"].filter(
      (tab) => ((sortedReservations[p.id] || {})[tab] || []).length > 0,
    );
  };

  const tabLabels = {
    current: "Current",
    upcoming: "Upcoming",
    past: "Past",
    contacts: "Contacts",
  };

  const selectTab = (participant, tab) => {
    setSelectedTabs({ selectedTabs, [participant.id]: tab });
  };

  const decrementIndex = (participant, tab) => {
    let current = indexes[participant.id][tab];

    setIndexes({
      ...indexes,
      [participant.id]: {
        ...indexes[participant.id],
        [tab]: Math.max(0, current - 1),
      },
    });
  };

  const incrementIndex = (participant, tab) => {
    let current = indexes[participant.id][tab];
    let max = sortedReservations[participant.id][tab].length - 1;

    setIndexes({
      ...indexes,
      [participant.id]: {
        ...indexes[participant.id],
        [tab]: Math.min(max, current + 1),
      },
    });
  };

  const connectionInfo = (p) => {
    console.log("Getting connections:", p);

    let accounts = (p.connections || []).filter((c) => !!c.account);
    let reservations = (p.connections || []).filter((c) => !!c.reservation);
    let contacts = (p.connections || []).filter((c) => !!c.contact);

    let tabs = reservationTabs(p) || [];
    let activeTab = selectedTabs[p.id] || tabs[0];
    let index = (indexes[p.id] || {})[activeTab] || 0;

    let reservation = sortedReservations[p.id][activeTab][index];

    const rentOwed = Number(reservation?.rent_owed || 0);
    const rentTotal = Number(reservation?.rent_total || 0);
    const doorCode = getReservationDoorCode(reservation);

    console.log("PID:", p.id);
    console.log("Sorted", sortedReservations[p.id][activeTab]);
    console.log("Active Tab:", activeTab);
    console.log("Indexes:", indexes);

    return (
      <div className="uk-card uk-card-default uk-card-small uk-card-body hms-msg-cards hms-booking-info">
        <div
          className="bookings rbr-pill-toggle rbr-task-status-toggle rbr-email-connection-tabs"
          role="tablist"
          aria-label="Reservations"
        >
          {tabs.map((tab) => {
            const label = tabLabels[tab];
            const isActive = tab === activeTab;

            return (
              <button
                type="button"
                role="tab"
                aria-selected={isActive}
                className={`rbr-pill-toggle-button${isActive ? " is-active" : ""}`}
                key={tab}
                onClick={() => selectTab(p, tab)}
              >
                {label} ({sortedReservations[p.id][tab].length})
              </button>
            );
          })}
        </div>
        {activeTab === "contacts" ? (
          <div>
            <div className="uk-margin-small-top">
              <div className="guest-chat-info-wrapper">
                {sortedReservations[p.id][activeTab].length > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div className="email-participant-row-count">
                      Contact {((indexes[p.id] || {})[activeTab] || 0) + 1} of{" "}
                      {sortedReservations[p.id][activeTab].length}
                    </div>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <span
                        className="uk-icon-button"
                        onClick={() => decrementIndex(p, activeTab)}
                      >
                        <FeatherIcon
                          name="chevron-left"
                          className="guest-detail-icon"
                        />
                      </span>
                      <span
                        className="uk-icon-button"
                        onClick={() => incrementIndex(p, activeTab)}
                      >
                        <FeatherIcon
                          name="chevron-right"
                          className="guest-detail-icon"
                        />
                      </span>
                    </div>
                  </div>
                )}

                <div className="uk-margin-small message-text-group">
                  <div className="uk-margin-small message-text-group">
                    <span uk-tooltip="Reservation Number">
                      <Image
                        src={`/images/${reservation.category}-active.svg`}
                      />
                    </span>
                    <div className="chat-value">
                      {CATEGORY_OPTIONS[reservation.category] || "Other"}
                    </div>
                  </div>
                </div>

                <div className="uk-margin-small message-text-group">
                  <div className="uk-margin-small message-text-group">
                    <span uk-tooltip="Reservation Number">
                      <FeatherIcon name="hash" className="guest-detail-icon" />
                    </span>
                    <div className="chat-value">
                      {reservation.formatted_phone || "No phone number"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="uk-margin-small-top">
            <div className="guest-chat-info-wrapper">
              {sortedReservations[p.id][activeTab].length > 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="email-participant-row-count">
                    Booking {((indexes[p.id] || {})[activeTab] || 0) + 1} of{" "}
                    {sortedReservations[p.id][activeTab].length}
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <span
                      className="uk-icon-button"
                      onClick={() => decrementIndex(p, activeTab)}
                    >
                      <FeatherIcon
                        name="chevron-left"
                        className="guest-detail-icon"
                      />
                    </span>
                    <span
                      className="uk-icon-button"
                      onClick={() => incrementIndex(p, activeTab)}
                    >
                      <FeatherIcon
                        name="chevron-right"
                        className="guest-detail-icon"
                      />
                    </span>
                  </div>
                </div>
              )}

              {reservation.category === "CXL" && (
                <div className="hms-booking-tag uk-margin-small-top cancelled">
                  Cancelled Booking
                </div>
              )}
              <div className="uk-margin-small-top message-text-group">
                <span uk-tooltip="Check-In - Check-Out">
                  <FeatherIcon name="calendar" className="guest-detail-icon" />
                </span>
                <div className="chat-value">
                  {moment(reservation?.check_in).format("MMM DD, YYYY")} -{" "}
                  {moment(reservation?.check_out).format("MMM DD, YYYY")}
                </div>
              </div>

              <div className="uk-margin-small message-text-group">
                <span uk-tooltip="Property ID">
                  <FeatherIcon name="home" className="guest-detail-icon" />
                </span>
                <div className="chat-value">
                  <div>{reservation?.pms_id}</div>
                  {reservation?.rental_id && (
                    <div style={{ textAlign: "left" }}>
                      <span
                        className="guest-detail-more-info"
                        uk-tooltip="Property Details"
                        onClick={(e) => {
                          e.preventDefault();
                          // setCurrentReservation(reservation);
                          // setPropertyDetailsOpen(true);
                        }}
                      >
                        Details
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className="uk-margin-small message-text-group">
                <span uk-tooltip="Address">
                  <FeatherIcon name="map-pin" className="guest-detail-icon" />
                </span>
                <div className="chat-value">{reservation?.pms_address}</div>
              </div>

              <div className="uk-margin-small message-text-group">
                <span uk-tooltip="Reservation Number">
                  <FeatherIcon name="hash" className="guest-detail-icon" />
                </span>
                <div className="chat-value">
                  <ReservationNumber
                    hostID={reservation?.host_id}
                    pms={user?.details?.pms}
                    resevationID={reservation?.reservation_id}
                    nativeID={reservation?.native_id}
                  />
                </div>
              </div>

              <div className="uk-margin-small message-text-group">
                <span uk-tooltip="Door Code">
                  <FeatherIcon name="lock" className="guest-detail-icon" />
                </span>
                <div className="chat-value">{doorCode}</div>
              </div>

              {reservation?.source && (
                <div className="uk-margin-small message-text-group">
                  <span uk-tooltip="Booking Source">
                    <FeatherIcon name="globe" className="guest-detail-icon" />
                  </span>
                  <div className="chat-value">{reservation?.source}</div>
                </div>
              )}

              {reservation?.guest_reservation_id && (
                <div className="uk-margin-small message-text-group">
                  <span uk-tooltip="Guest Book">
                    <FeatherIcon
                      name="book-open"
                      className="guest-detail-icon"
                    />
                  </span>
                  <div className="chat-value">
                    <a
                      href={`${host}/v2/reservations/guestbook/${reservation.guest_reservation_id}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Guestbook
                    </a>
                  </div>
                </div>
              )}

              {(user?.details?.pms === "Streamline" ||
                user?.details?.pms === "LiveRez" ||
                user?.details?.pms === "Hostaway" ||
                user?.details?.pms === "OwnerRez") && (
                <div className="uk-margin-small message-text-group">
                  <span
                    uk-tooltip={
                      reservation?.contract_signed
                        ? "Contract Signed"
                        : "Contract Not Signed"
                    }
                  >
                    <FeatherIcon
                      name={
                        reservation?.contract_signed
                          ? "check-circle"
                          : "alert-circle"
                      }
                      className={`guest-detail-icon ${!reservation?.contract_signed ? "icon-red" : ""}`}
                    />
                  </span>

                  <div className="chat-value">
                    {reservation?.contract_signed ? (
                      "Contract Signed"
                    ) : (
                      <span style={{ color: "var(--red)" }}>
                        Contract Not Signed
                      </span>
                    )}
                  </div>
                </div>
              )}

              {(user?.details?.pms === "Streamline" ||
                user?.details?.pms === "LiveRez" ||
                user?.details?.pms === "OwnerRez") &&
                !String(reservation?.source || "")
                  .toLowerCase()
                  .includes("airbnb") &&
                !String(reservation?.source || "")
                  .toLowerCase()
                  .includes("vrbo") &&
                !String(reservation?.source || "")
                  .toLowerCase()
                  .includes("booking.com") &&
                rentTotal > 0 && (
                  <div className="uk-margin-small message-text-group">
                    <span
                      uk-tooltip={rentOwed > 0 ? "Rent Owed" : "Paid in Full"}
                    >
                      <FeatherIcon
                        name="dollar-sign"
                        className={`guest-detail-icon ${rentOwed > 0 ? "icon-red" : ""}`}
                      />
                    </span>

                    <div className="chat-value">
                      {rentOwed > 0 ? (
                        <span
                          style={{ color: "var(--red)" }}
                        >{`Rent Owed: $${formatMoney(rentOwed)}`}</span>
                      ) : (
                        `Rent Total: $${formatMoney(rentTotal)}`
                      )}
                    </div>
                  </div>
                )}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="hms-booking-info-wrapper email-thread-details">
      <div className="hms-guest-identity-card">
        <div className="message-text-group guest-info">
          <span
            className="message-text-group-icon team-thread-details-avatar"
            uk-tooltip="Email Conversation"
          >
            <img src={iconSrc} alt="Email Conversation" />
          </span>
          <div className="uk-width-expand">
            <div className="guest-chat-info">
              <div className="team-thread-name-row">
                <div className="chat-guest-value semi-bold-font">{subject}</div>
              </div>

              <div className="chat-guest-value team-thread-summary">
                {participantCount} participant
                {participantCount === 1 ? "" : "s"}
              </div>
            </div>
          </div>
        </div>

        <div className="email-participant-list">
          <div className="email-participant-heading">Participants</div>
          {participants.map((participant) => {
            return (
              <div>
                <div
                  className="message-text-group guest-info email-participant-row"
                  key={participant.personal_inbox_id}
                >
                  <span className="team-message-avatar">
                    {getBubble(participant)}
                  </span>
                  <div className="uk-width-expand">
                    <div className="guest-chat-info">
                      <div className="chat-guest-value semi-bold-font">
                        {participant.name}
                        {isSelf(participant) ? " (you)" : ""}
                      </div>
                      {participant.email && (
                        <div className="chat-guest-value email-participant-email">
                          {participant.email}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="uk-card email-participant-card">
                  <ul className="uk-accordion-default" data-uk-accordion>
                    <li>
                      <div className="email-participant-count uk-accordion-title">
                        {participant.connections?.length || 0} Connections
                      </div>
                      {!!participant.connections && (
                        <ul className="chat-email-connections uk-list uk-accordion-content">
                          {connectionInfo(participant)}
                        </ul>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EmailDetails;
